import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { withStyles, Button, CircularProgress, Typography, FormGroup, FormControlLabel, Paper, Checkbox } from "@material-ui/core";
import { connect } from "react-redux";
import { BackButton, hasPermission } from '../../../../sc-utilities';
import * as actions from "../../store/deviceCaseSupportedActions";
import * as diagnoseCaseActions from '../../../../sc-settings/CustomerDiagnoseCase/store/customerDiagnoseCaseActions';
import * as adminDiagnoseCaseActions from '../../../../sc-admin/AdminDiagnoseCase/store/adminDiagnoseCaseActions';
import History from "../../../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    form: {
        width: '95%',
        margin: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    text: {
        borderRadius: '1px',
        marginRight: 10,
        color: theme.palette.buttonText.default
    },
    divider: {
        margin: theme.spacing(1),
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right',
        padding: theme.spacing(2),
    }
});
const DeviceCaseSupportedDiagnoseDetailsMotherboard = (props) => {
    const { classes, translations, onEditDeviceCaseSupportedDiagnoseCaseParams, permissions, onUpdateAdminDiagnoseCaseParams, onUpdateCustomerDiagnoseCaseParams, activeCustomerID } = props;

    const diagnoseCase = props.location.state.redirectOptions?.rowData;

    const DeviceCaseSupportedID = diagnoseCase?.DeviceCaseSupportedID;

    const isSystemDiagnoseCase = props.location.state?.redirectOptions?.isSystemDiagnoseCase ?? false;

    let hasUpdatePermission = false;
    let caseParams = {};
    if (DeviceCaseSupportedID) {
        hasUpdatePermission = hasPermission(permissions, "system_device_case_supported_update_params");
        caseParams = diagnoseCase?.DeviceCasesSupported?.[0]?.CaseParams || {};
    } else {
        hasUpdatePermission = hasPermission(permissions, isSystemDiagnoseCase ? "diagnose_case_update" : "customer_diagnose_case_update");
        caseParams = diagnoseCase?.ThresholdParams || {};
    }

    const initialValues = {
        cmos_checksum: caseParams?.cmos_checksum ?? true,
        cmos_battery: caseParams?.cmos_battery ?? true,
        rtc: caseParams?.rtc ?? true,
        uefi: caseParams?.uefi ?? false,
        dmi: caseParams?.dmi ?? true
    }

    const formSettings = {
        Validation: {
            cmos_checksum: Yup.boolean(),
            cmos_battery: Yup.boolean(),
            rtc: Yup.boolean(),
            uefi: Yup.boolean(),
            dmi: Yup.boolean(),
        },
        FormTitle: translations["update_parameters"] || "Update parameters",
        ButtonSubmit: hasUpdatePermission ?
            {
                Title: translations["save"] || "SAVE"
            } : null
    }
    const handleEdit = async (data) => {
        const CaseParams = { cmos_checksum: data.cmos_checksum, cmos_battery: data.cmos_battery, rtc: data.rtc, uefi: data.uefi, dmi: data.dmi };

        if (DeviceCaseSupportedID) {
            await onEditDeviceCaseSupportedDiagnoseCaseParams({
                CaseParams,
                DiagnoseCaseID: diagnoseCase.DiagnoseCaseID,
                DeviceCaseSupportedID
            });
        } else {
            isSystemDiagnoseCase
                ? await onUpdateAdminDiagnoseCaseParams({
                    CaseParams,
                    DiagnoseCaseID: diagnoseCase.DiagnoseCaseID,
                })
                : await onUpdateCustomerDiagnoseCaseParams({
                    CaseParams,
                    DiagnoseCaseID: diagnoseCase.DiagnoseCaseID,
                    ActiveCustomerID: activeCustomerID,
                });
        }
        History.goBack();
    }
    return (
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={handleEdit}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, isSubmitting, handleChange, isValid, dirty, handleSubmit } = formikProps;
                    return (
                        <form className={classes.form} onSubmit={handleSubmit}>
                            <>
                                <Typography align='center' variant={"h5"}>{translations['motherboard'] || 'Motherboard'}</Typography>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={"dense"}
                                                name={"cmos_checksum"}
                                                checked={values.cmos_checksum}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['cmos_checksum'] || 'CMOS checksum'}`}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={"dense"}
                                                name={"cmos_battery"}
                                                checked={values.cmos_battery}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['cmos_battery'] || 'CMOS battery'}`}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={"dense"}
                                                name={"rtc"}
                                                checked={values.rtc}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['rtc'] || 'RTC'}`}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={"dense"}
                                                name={"uefi"}
                                                checked={values.uefi}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['uefi'] || 'UEFI'}`}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                margin={"dense"}
                                                name={"dmi"}
                                                checked={values.dmi}
                                                onChange={handleChange}
                                            />
                                        }
                                        label={`${translations['dmi'] || 'DMI'}`}
                                    />
                                </FormGroup>
                            </>
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
}
const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onEditDeviceCaseSupportedDiagnoseCaseParams: params => dispatch(actions.editDeviceCaseSupportedDiagnoseCaseParams(params)),
        onUpdateAdminDiagnoseCaseParams: (params) => dispatch(adminDiagnoseCaseActions.updateAdminDiagnoseCaseParams(params)),
        onUpdateCustomerDiagnoseCaseParams: (params) => dispatch(diagnoseCaseActions.updateCustomerDiagnoseCaseParams(params)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DeviceCaseSupportedDiagnoseDetailsMotherboard));